import { Guest } from "../../invitation/guest/guest.model";

export class GuestReport{
    date: Date;
    entry: number;
    leave: number;
    idBuilding: number;   
    idCompany: number;
    buildingName: string;
    companyName: string;
}

export enum GuestReportType{
    Guest = "guest",
}